const line = {
  el: document.getElementById('jsStickySection') as HTMLElement | null,
  header: document.getElementById('jsStickyHeader') as HTMLElement | null,
  sections: document.querySelectorAll('.jsSection') as NodeListOf<HTMLElement>,
  links: document.querySelectorAll('.jsLink') as NodeListOf<HTMLElement>,

  init() {
    this.setSticky();
    this.setActiveSection();
  },

  setSticky() {
    if (!this.el || !this.header) {
      return;
    }

    const stickyOffset =
      parseInt(window.getComputedStyle(this.el).top, 10) || 0;
    const buffer = 50;

    window.addEventListener('scroll', () => {
      const rect = this.el!.getBoundingClientRect();

      const isSticky = rect.top === stickyOffset;
      const isApproachingSticky = rect.top <= stickyOffset + buffer && rect.top > stickyOffset;
      const isJustUnstuck = rect.top < stickyOffset && rect.top >= stickyOffset - buffer;

      if (isSticky || isApproachingSticky || isJustUnstuck) {
        this.header!.classList.add('activeLine'); // Hide
      } else {
        this.header!.classList.remove('activeLine'); // Show
      }
    });
  },

  setActiveSection() {
    const scrollHandler = () => {
      let current = '';

      this.sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (pageYOffset >= sectionTop - 60) {
          current = section.getAttribute('id') || '';
        }
      });

      this.links.forEach((item) => {
        item.classList.remove('activeClass');
        if (item.getAttribute('href') === `#${current}`) {
          item.classList.add('activeClass');
        }
      });
    };

    window.addEventListener('scroll', scrollHandler);
    scrollHandler(); // Call once on load
  },
};

export default line;
